import React from "react";
import travelImage from "../../Assests/newHomeImgs/info.png"; // Image of travel illustration
import { SectionHeading } from "../UI/Card";

const aboutRasuData = {
  title: "Your Travel Booking Partner",
  description: `
Founded in 2025, <strong>RasuTrip</strong> has emerged as one of India's most reliable and customer-centric online travel booking platforms. With a presence across major cities, we offer a comprehensive range of travel services including bus bookings, flight reservations (domestic and international), and hotel accommodations.
</br></br>

Whether you're planning a spontaneous weekend trip, a family vacation, or a professional tour, RasuTrip brings convenience and affordability right to your fingertips. We believe that travel should be smooth, secure, and enjoyable — and our platform reflects just that.
</br></br>

By partnering with leading bus operators, renowned airlines like Akasa Air, and top-rated hotels in cities like Mumbai, we ensure you get the best deals, flexible options, and a hassle-free booking experience.
</br></br>

From hill stations to metro cities, travel with confidence knowing that <strong>RasuTrip</strong> has your journey covered from start to finish. Let every trip begin with trust and comfort — book with RasuTrip today!
  `,
};

const AboutRasu = () => {
  return (
    <section className="max-w-[1280px] mx-auto px-5 sm:px-6 py-14">
      <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
        <div className="w-full lg:w-[42%]">
          <img
            src={travelImage}
            alt="RasuTrip Travel"
            className="w-full h-auto rounded-2xl shadow-card"
          />
        </div>

        <div className="w-full lg:w-[58%]">
          <SectionHeading eyebrow="About RasuTrip" title={aboutRasuData.title} className="mb-5" />
          <p
            className="text-ink-500 text-[15px] leading-relaxed"
            dangerouslySetInnerHTML={{ __html: aboutRasuData.description }}
          />
        </div>
      </div>
    </section>
  );
};

export default AboutRasu;
